import type { EnumUnion } from '@dresscode-frontend/utility-types';

export const Columns = {
  PERSON: 'person',
  SOFTWARE: 'software',
  JOB_TYPE: 'jobTypes',
  DEPARTMENT: 'departments',
  POSITION: 'positions',
  PLACE: 'place',
  JOINED_ON: 'joinedOn',
  LEFT_ON: 'leftOn',
  ACTION: 'actions',
} as const;

export type Columns = EnumUnion<typeof Columns>;
